import { notification } from 'antd'

export generateFieldData = (dataMap, formId) ->
  index = 0
  _.reduce(dataMap, (acc, value, key) ->
    acc = [
      acc...
      {
        name: [formId, index, 'key']
        value: key
      }, {
        name: [formId, index, 'value']
        value
      }
    ]
    index++
    acc
  , [])

export showGenericErr = ->
  notification.open({
    message: 'Whoops!'
    description:
      """
        An error occured. Please refresh the page and try again.
        If the issue persists please contact an administrator.
      """
  })
